import { LogItem } from "../../../backend/backendapi";

export enum LogEvent {
    TICKET,
    BOARD,
    CARD
}

export class LogItemVM {
    logItem: LogItem;
    logEvent: LogEvent;
    info: string;
    customEvent: any;

    constructor(logItem: LogItem, logEvent: LogEvent, info: string, customEvent: any) {
        this.logItem = logItem;
        this.logEvent = logEvent;
        this.info = info;
        this.customEvent = customEvent;
    }
}